<template>
<div class="chapter">
<div class="inner_page">
<section class="div_autre" epub:type="preamble">
<div class="pre" id="pre-006"><span epub:type="pagebreak" id="page_XIII" role="doc-pagebreak" title="XIII">
<h1 class="pre_tit" epub:type="title"><span><a class="renvlnk" id="renv_XIII">ABBREVIATIONS</a></span></h1><a class="renvlnk" id="renv_XIII">
<div class="dev">
<div class="tableau" id="tableau-001">
<div class="table-align">
<table style="border-collapse:collapse; border-spacing:0px;">
<colgroup style="padding:7px;">
<col style="padding:7px;"/>
<col style="width:84.06%;"/>
</colgroup>
<tbody>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">ANF</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">A. Roberts and J. Donaldson, eds. Ante-Nicene Fathers. 10 vols. Buffalo, NY: Christian Literature, 1885–1896. Reprint, Grand Rapids, MI: Eerdmans, 1951–1956; Reprint, Peabody, MA: Hendrickson, 1994.</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">BoC</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>The Book of Concord: The Confessions of the Evangelical Lutheran Church</i>. Translated and edited by Theodore G. Tappert et al. Philadelphia: Fortress: 1959.</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">CCCM</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Corpus Christianorum, Continuatio Mediaevalis. Turnhout: Brepols, 1966–.</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">CO</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>Ioannis Calvini Opera Quae Supersunt Omnia</i>. 59 vols. Corpus Reformatorum 29–88. Ed. G. Baum, E. Cunitz, E. Reuss. Brunswick and Berlin, 1863–1900.</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">CR</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>Corpus Reformatorum</i>. Edited by C. G. Bretschneider. Halle, 1834–1860.</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">CRR</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Classics of the Radical Reformation. 12 vols. Waterloo, ON, and Scottsdale, PA: Herald Press, 1973–2018. Reprint, Walden, NY: Plough Publishing House, 2019–.</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">CTS</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Calvin Translation Society edition of Calvin’s commentaries. 46 vols. Edinburgh, 1843–1855. Several reprints, but variously bound; volume numbers (when cited) are relative to specific commentaries and not to the entire set.</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">CWE</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>Collected Works of Erasmus</i>. 86 vols. planned. Toronto: University of Toronto Press, 1969–.</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">LCC</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">John Baillie et al., eds. The Library of Christian Classics. 26 vols. Philadelphia: Westminster, 1953–1966.</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">LFC</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Library of the Fathers of the Holy Catholic Church. 48 vols. Oxford: John Henry Parker, 1838–1888.</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">LW</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>Luther’s Works</i> [= “American Edition”]. 82 vols. planned. St. Louis: Concordia; Philadelphia: Fortress, 1955–1986; 2009–.</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">MO</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>Philippi Melanthonis Opera Quae Supersunt Omnia</i>. 28 vols. Corpus Reformatorum 1–28. Ed. C. G. Bretschneider. 1834–60; reprint ed.; New York: Johnson, 1963.</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">NPNF<sup>1</sup></p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">P. Schaff et al., eds. A Select Library of the Nicene and Post-Nicene Fathers of the Christian Church. 2 series (14 vols. each). Buffalo, NY: Christian Literature, 1887–1894; Reprint, Grand Rapids, MI: Eerdmans, 1952–1956; Reprint, Peabody, MA: Hendrickson, 1994.</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">PG</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">J.-P. Migne, ed. Patrologiae cursus completus. Series Graeca. 166 vols. Paris: Migne, 1857–1886.</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><span epub:type="pagebreak" id="page_XIV" role="doc-pagebreak" title="XIV"><a class="renvlnk" id="renv_XIV">PL</a></span></p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">J.-P. Migne, ed. Patrologiae cursus completes. Series Latina. 221 vols. Paris: Migne, 1844–1864.</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Vg.</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Vulgate</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">WA</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>D. Martin Luthers Werke: Kritische Gesamtausgabe</i>. 66 vols. Weimar: Hermann Böhlaus Nachfolger, 1883–1987.</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">WA, DB</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>D. Martin Luthers Werke: Kritische Gesamtausgabe: Deutsche Bibel</i>. 12 vols. Weimar: Hermann Böhlaus Nachfolger, 1906–1961.</p></td>
</tr>
<tr style="padding:7px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">WA, Tr</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>D. Martin Luthers Werke: Kritische Gesamtausgabe: Tischreden</i>. 6 vols. Weimar: Hermann Böhlaus Nachfolger, 1912–1921.</p></td>
</tr>
</tbody>
</table>
</div>
</div>
</div>
</a></span></div><a class="renvlnk" id="renv_XIII">
</a></section><a class="renvlnk" id="renv_XIII">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// pre3.vue?6e499c74